import { AppLayout } from '@/components/layout/AppLayout';
import { HospitalDashboardView } from '@/components/views/HospitalDashboardView';

export function HospitalDashboardPage() {
  return (
    <AppLayout>
      <HospitalDashboardView />
    </AppLayout>
  );
}
